<template>
  <div class="input-container">
    <label for="$Search" class="label">{{ title }}</label>
    <input id="$Search" v-model="search" type="text" class="input" @keypress.enter.prevent="searchImage" @input="searched = false">
    <div>
      <div v-if="searched === true && !images.length">No se encontaron imágenes con el nombre {{ search }}</div>
    </div>
    <div class="images-search-container">
      <div v-for="image in images" :key="image.image" class="center" @click="selectImage(image)">
        <div>{{ image.image }}</div>
        <img :src="`https://sahet-cdn.b-cdn.net/${image.dir}`" :alt="image.image">
      </div>
    </div>
  </div>
</template>

<script>
import shInput from '@/components/elements/Input'
import gqlImage from '@/graphql/image'
import gql from '@my/graphql'

export default {
  name: 'Search',

  data () {
    return {
      search: '',
      images: [],
      searched: false,
      defaultFolder: 'https://sahet-cdn.b-cdn.net/'
    }
  },

  props: { title: { type: String, default: 'Buscar' } },

  components: { shInput },

  methods: {
    async searchImage () {
      const query = gqlImage.GET_BY_IMAGE

      if (!this.search) {
        this.images = []
        return
      }

      const response = await gql.query(query, { image: this.search })

      if (response && response.data && response.data.getByImage) {
        this.images = response.data.getByImage
      }

      this.searched = true
    },

    selectImage (image) {
      this.$emit('selectImage', image)
    }
  }
}
</script>

<style>
.images-search-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 1em;
  gap: 1em;
}

.images-search-container img {
  width: 20em;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/product/Search.vue